import React from 'react'
import styled, { css } from 'styled-components'
import { space, color, typography } from 'styled-system'

const Typography = ({ variant, ...props }) => {
  const variants = {
    title: <Title {...props} />,
    semiTitle: <SemiTitle {...props} />,
    text: <Text {...props} />,
    paragraph: <Paragraph {...props} />,
    subtitle: <Subtitle {...props} />,
  }

  return variants[variant]
}
Typography.defaultProps = {
  variant: 'text',
}

/**
 * Common Styles
 */
const fontStyles = css`
  font-family: ${props => props.theme.fonts.body};
  font-size: ${props => props.theme.fontSizes.body};
  color: ${props => props.theme.colors[props?.color] || props.theme.colors.text};
  text-decoration: ${({ textDecoration = 'none' }) => textDecoration};

  ${space}
`

/**
 * Typography components
 */
export const Title = styled.h1`
  ${fontStyles}

  font-weight: ${props => props.theme.fontWeights.extraBold};

  font-size: ${props => props.theme.fontSizes[props.as]};

  ${typography}
  ${color}
`
Title.defaultProps = {
  as: 'h1',
}

export const SemiTitle = styled(Title)`
 ${fontStyles}

 color: ${({ color }) => color};
 font-size: ${props => props.theme.fontSizes[props.as]};
`

SemiTitle.defaultProps = {
  as: 'h5',
}

export const Text = styled.span`
  ${fontStyles}
  color: ${props => props.color};
  font-weight: ${props => props.fontWeight};

  ${color}
`

export const Paragraph = styled.p`
  ${fontStyles}
  margin: 0;
  margin-top: 1em;

  ${props =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${color}
`

export const Subtitle = styled.span`
  ${fontStyles}

  color: ${({ color }) => color};
  font-size: ${props => props.theme.fontSizes[0]};

  ${color}
`

export default Typography
